Vue.component("MpModuleScrollable", {
    props: {
        source: String,
        title: String,
        type: String,
        moduleName: String,
    },
    data: function() {
        return {
            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',
            DELAY_VARIATION: 4000,

            TYPE_VIDEOS: 'videos',
            TYPE_SHARES: 'shares',
            TYPE_INTEVIEWS: 'interviews',
            TYPE_SECTORCARDS: 'sectorcards',


            scrollableModule: null,

            itemList: [],
        };
    },
    computed: {},
    methods: {

        next: function() {
            this.scrollableModule.slideNext();
        },

        previous: function() {
            this.scrollableModule.slidePrev();
        },

        initSwiper: function() {

            this.scrollableModule = new Swiper(this.$refs.carousel, {
                slidesPerView: 'auto',
                allowTouchMove: false,
                simulateTouch: false,
                loop: true,
                autoplay: {
                    delay: this.DELAY_VARIATION + Math.round(this.DELAY_VARIATION*Math.random()),
                }
            });
        },

        onSourceDataLoad: function(response) {

            if (response.statusText !== this.RESPONSE_OK) {
                return;
            }

            // console.log(this.type, response);

            switch (this.type) {
                case this.TYPE_VIDEOS:
                case this.TYPE_SHARES:
                case this.TYPE_SECTORCARDS:
                    this.itemList = response.data;
                break;
                case this.TYPE_INTEVIEWS:
                    this.itemList = response.data.active;
                break;
            }

            Vue.nextTick(this.initSwiper);
        },

        loadSource: function() {
            axios
                .get(this.source)
                .then(this.onSourceDataLoad)
                .catch(function(error) {
                    console.log(error);
                });
        },

        init: function() {
            this.loadSource();
        }
    },

    mounted: function() {
        this.init();
    },

    updated: function() {},

    template: '\
    <div class="swiper-container" ref="carousel" v-if="itemList.length">\
        <h4 class="mini-gallery__title">{{title}}</h4>\
\
        <a class="mini-gallery__nav-btn mini-gallery__nav-btn--prev" href="#" @click.prevent="previous()"></a>\
        <a class="mini-gallery__nav-btn mini-gallery__nav-btn--next" href="#" @click.prevent="next()"></a>\
\
        <div class="swiper-wrapper">\
            <div class="swiper-slide" v-for="item in itemList">\
                <a class="mini-gallery__slide-link" :href="item.url" :target="item.target" :title="item.titulo" v-if="!item.titulo">\
                    <img class="mini-gallery__slide-link-img" :src="item.imagen" :alt="item.titulo"/>\
                </a>\
\
                <article class="post-mini" v-if="item.titulo">\
                    <img class="post-mini__img" :src="item.imagen">\
\
                    <h3 class="post-mini__title">\
                        <a class="post-mini__title-link" :href="item.url" :target="item.target">{{item.titulo}}</a>\
                    </h3>\
\
                    <p class="post-mini__text" v-if="item.detalle">{{item.detalle}}</p>\
                </article>\
            </div>\
        </div>\
    </div>',
});
